import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

export type ValidateUsersFilters = {
  location: string;
  searchValue: string;
};

export type ValidateUsersStore = {
  filters: ValidateUsersFilters;
  excluded: string[];
  setFilters: (filters: Partial<ValidateUsersFilters>) => void;
  toggleExcluded: (id: string) => void;
  reset: () => void;
};

const defaultFilters: ValidateUsersFilters = {
  location: '',
  searchValue: '',
};

export const useValidateUsersStore = createStoreWithSubscribe<ValidateUsersStore>(
  (set) => ({
    filters: defaultFilters,
    excluded: [],
    setFilters: (filters: Partial<ValidateUsersFilters>) =>
      set((state) => ({ ...state, filters: { ...state.filters, ...filters } })),
    toggleExcluded: (id: string) =>
      set((state) => ({
        ...state,
        excluded: state.excluded.includes(id) ? state.excluded.filter((e) => e !== id) : [...state.excluded, id],
      })),
    reset: () => set((state) => ({ ...state, filters: defaultFilters, excluded: [] })),
  }),
  {
    name: 'ValidateUsersStore',
    trace: true,
  }
);

export const useValidateUsersShallowStore = createShallowStore(useValidateUsersStore);
